const ALLEPPEY_HERO = '/images/gallery/destinations/alleppey3.jpg';

const homestayGallery = [
  '/images/packages/homestay/DSC_9815.jpg',
  '/images/packages/homestay/DSC_9819.jpg',
  '/images/packages/homestay/DSC_9823.jpg',
  '/images/packages/homestay/DSC_9826.jpg',
  '/images/packages/homestay/DSC_9829.jpg',
  '/images/packages/homestay/DSC_9832.jpg',
  '/images/packages/homestay/DSC_9835.jpg',
  '/images/packages/homestay/DSC_9837.jpg',
  '/images/packages/homestay/DSC_9838.jpg',
  '/images/packages/homestay/DSC_9839.jpg',
  '/images/packages/homestay/DSC_9846.jpg',
  '/images/packages/homestay/DSC_9847.jpg',
  '/images/packages/homestay/DSC_9849.jpg',
  '/images/packages/homestay/DSC_9855.jpg',
  '/images/packages/homestay/DSC_9859.jpg',
  '/images/packages/homestay/DSC_9864.jpg',
  '/images/packages/homestay/DSC_9866.jpg',
  '/images/packages/homestay/DSC_9868.jpg',
  '/images/packages/homestay/DSC_9874.jpg',
  '/images/packages/homestay/DSC_9875.jpg',
  '/images/packages/homestay/DSC_9882.jpg',
  '/images/packages/homestay/DSC_9885.jpg',
  '/images/packages/homestay/DSC_9889.jpg',
  '/images/packages/homestay/DSC_9892.jpg',
  '/images/packages/homestay/DSC_9895.jpg',
  '/images/packages/homestay/DSC_9901.jpg',
  '/images/packages/homestay/DSC_9904.jpg',
  '/images/packages/homestay/DSC_9906.jpg',
  '/images/packages/homestay/DSC_9908.jpg',
  '/images/packages/homestay/DSC_9911.jpg',
  '/images/packages/homestay/DSC_9913.jpg',
  '/images/packages/homestay/DSC_9915.jpg',
  '/images/packages/homestay/DSC_9919.jpg',
  '/images/packages/homestay/DSC_9921.jpg',
  '/images/packages/homestay/DSC_9923.jpg',
  '/images/packages/homestay/DSC_9926.jpg',
  '/images/packages/homestay/DSC_9929.jpg',
  '/images/packages/homestay/DSC_9931.jpg',
  '/images/packages/homestay/DSC_9937.jpg',
  '/images/packages/homestay/DSC_9939.jpg',
];

export const packagesData = {
  alleppey: {
    id: 'alleppey',
    title: 'Alleppey – One & Two Day Incredible Destination',
    days: 2,
    tagline: 'Experience the Venice of the East with our budget-friendly homestay and backwater adventures',
    heroImage: ALLEPPEY_HERO,
    gallery: homestayGallery,
    overview: `Alappuzha (Alleppey) is embedded with cultural, religious, and natural beauty — lakes and backwaters that have earned it the title "Venice of the East" in the tourist world. To make it a budget-friendly trip, we offer our own homestay with 3 fully furnished AC rooms with attached bathrooms, balcony, lobbies, meeting place, breakfast and dining room, modular kitchen, and a beautiful lawn — a true home away from home. The homestay is centrally located, 7–10 km from all major tourist spots in Alleppey, and can accommodate a family of up to 15 persons at a very affordable rate. We can fully customize the experience according to your choice and budget.`,
    highlights: [
      'Shikara ride on the backwaters with Arabian Sea views',
      'Pathiramanal Island bird sanctuary visit by motor boat',
      'Authentic Kerala lunch and breakfast at our homestay',
      'Optional canoe ride for swimmers and youngsters',
      'Day cruise with lunch on a motorized houseboat',
      'Village walk through paddy fields and local markets',
      'Alleppey Lighthouse and beach experiences',
      'Optional religious visits to ancient temples and churches',
    ],
    itinerary: [
      {
        day: 1,
        title: 'Backwaters & Pathiramanal Island',
        description: `8:30 AM – 12:30 PM (First Session): Experience a Shikara — a motorized, pilot-driven wooden boat on the backwaters. One to two hours of safe and enjoyable travel with sightseeing on dancing waves and close views of the Arabian Sea. For youngsters and those who can swim, we suggest a canoe ride — a small, lightweight watercraft that can be enjoyed alone or in pairs.

Return to the homestay for relaxation and an authentic Kerala lunch.

3:30 PM – 5:30 PM (Second Session): Take a motor boat to Pathiramanal Island — a lush 10-acre sanctuary on Vembanad Lake, famous as a pristine birdwatcher's paradise. Located between Alleppey and Kumarakom, this uninhabited island is accessible only by boat and is also known as "Sands of Midnight." The island hosts over 90 local bird species and roughly 50 migratory species, including pintail ducks, purple herons, and darters. Beyond birds, it features dense tropical vegetation, thick mangrove forests, and rare medicinal plants. Managed by Kerala Tourism Development Corporation, this is a safe experience the whole family can enjoy together.`,
        accommodation: 'Homestay – 3 AC rooms with attached bathrooms (up to 15 guests)',
        meals: 'Authentic Kerala lunch',
      },
      {
        day: 2,
        title: 'Cultural Visits, Day Cruise & Village Walk',
        description: `Those interested in religious sites can have a morning darshan at Ambalapuzha Temple, Mannarshala Temple, St. Andrew's Basilica (Arthungal Church), Kripasanam, or other ancient Shiva temples — followed by an authentic Kerala breakfast at 9:30 AM.

11:30 AM: Enjoy a day cruise for about 1–2 hours with lunch on a moving motorized boat. Some boats are double-decker and can accommodate 50–75 or even 100 travelers.

After disembarking around 2 PM, take a village walk through the paddy fields and/or local markets.

Alternatively, visit the Alleppey Lighthouse (permissible visiting time: 3:00 – 4:30 PM). Constructed and operational since 1862, this 92-foot cylindrical tower with a balcony and lantern offers panoramic views of the farthest cities surrounding Alleppey — a truly memorable experience.

Afterwards, visit Alleppey or Mararikulam beach and enjoy a traditional dinner at the beach or back at the homestay.`,
        accommodation: 'Homestay – 3 AC rooms with attached bathrooms (up to 15 guests)',
        meals: 'Authentic Kerala breakfast; lunch on day cruise',
      },
    ],
    inclusions: [
      'Homestay accommodation in 3 fully furnished AC rooms with attached bathrooms',
      'Balcony, lobbies, meeting place, breakfast and dining room, modular kitchen, and lawn',
      'Authentic Kerala meals as per itinerary',
      'Customizable activities according to visitor choice and budget',
      'Centrally located homestay, 7–10 km from major Alleppey tourist spots',
    ],
    exclusions: [
      'Boat bookings (priced based on exact travel dates)',
      'International or domestic airfare',
      'Personal expenses (laundry, telephone calls, etc.)',
      'Camera fees at monuments',
      'Travel insurance',
      'Optional Royal Cruise add-on',
    ],
    bestTimeToVisit: 'September to March offers the most pleasant weather for backwater experiences.',
    notes: `This itinerary can be customized for a 1-day or 2-day trip based on your preferences and budget. For boat bookings, we require exact dates to work out the budget. A 1-day option covering selected activities from Day 1 or Day 2 is also available.`,
    royalCruiseAddOn: `Royal Cruise is a fully furnished decorative boat resembling a palace room — ideal for honeymoon couples or elite visitors seeking a five-star hotel experience while cruising the backwaters day and night. While moving, it feels like a moving palace. Boats are available for one couple or up to 7 couples, each with independent AC rooms and private bathrooms.`,
  },
};

export const packagesList = Object.values(packagesData).map((pkg) => ({
  id: pkg.id,
  title: pkg.title,
  days: pkg.days,
  image: pkg.heroImage,
  shortDesc: pkg.tagline,
  highlights: pkg.highlights.slice(0, 4),
}));
